// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3VGs6","content":"App_content__3ZxkN"};